import { useEffect } from "react";

export function ReviewRedirect() {
  const reviewURL = "https://share.google/DJoHdR2mBDwqatJHj";

  useEffect(() => {
    window.location.replace(reviewURL);
  }, []);

  return (
    <>
      <meta http-equiv="refresh" content={`0;url=${reviewURL}`} />
      <p>Een ogenblik geduld, we sturen u door naar de volgende pagina.</p>
      <a href={reviewURL}>{reviewURL}</a>
    </>
  );
}
